var exports = {
  "x6": "DownloadButton.module__button___MWZITW",
  "td": "DownloadButton.module__iconText___MWZITW",
  "ro": "DownloadButton.module__menuIcon___MWZITW",
};

module.exports = exports;
